<template>
  <div v-if="assignment.item?.labelsCreationStatus !== 'error'" class="row">
    <div class="col-12">
      <button class="btn create-btn btn-green w-100" @click="openDownloadLabelsModal">Download Label</button>
    </div>
    <br />
    <div v-if="documentsUrl" class="col-12">
      <button class="btn create-btn btn-green w-100" @click="openDownloadDocuments">
        Download secondary documents
      </button>
    </div>
  </div>
  <div v-else class="center">
    <b>
      Label wasn't created. Please, try again later or <a href="mailto:support@21grams.com">contact support team</a>
    </b>
    <div class="mt-2">
      <b>Debug info:</b>
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import type { OptimisationPath } from '@/types/Models/Shipment'
import { computed, type ComputedRef, defineComponent, onMounted, ref, watch } from 'vue'
import { useDownloadLabelsAction } from '@/composables/Labels/useDownloadLabelsAction'
import { DOWNLOAD_LABELS, DOWNLOAD_LABELS_WARNING } from '@/const/ModalTypes'
import { registerModals } from '@/services/Modal'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useShipmentStore } from '@/store/shipment'

export default defineComponent({
  name: 'LabelsReleased',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const downloadLabelsAction = useDownloadLabelsAction()
    const shipmentStore = useShipmentStore()
    const errorMessage = ref('')

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const documentsUrl: ComputedRef<string> = computed(() => assignment.value?.documentsUrl || '')
    const optimisationPaths: ComputedRef<OptimisationPath[]> = computed(() =>
      shipmentStore.optimisationPathsList(assignment.value?.item?.id || null),
    )

    const openDownloadLabelsModal = () => (assignment.value ? downloadLabelsAction([assignment.value]) : null)

    const openDownloadDocuments = () => {
      window?.open(documentsUrl.value, '_blank')
    }

    onMounted(() => {
      registerModals(DOWNLOAD_LABELS)
      registerModals(DOWNLOAD_LABELS_WARNING)
    })
    watch(
      () => assignment.value?.item?.labelsCreationStatus,
      async (val) => {
        if (val === 'error' && assignment.value?.item?.id) {
          errorMessage.value = ''
          await shipmentStore.fetchOptimisationSummary(assignment.value.item.id, [])

          const paths = optimisationPaths.value ?? []
          errorMessage.value = paths
            .map((path: OptimisationPath) => {
              const metadata = typeof path.metadata === 'string' ? path.metadata : JSON.stringify(path.metadata ?? '')
              const match = metadata.match(/"message"\s*:\s*"([^"]+)"/)
              return match ? `${path.carrierHandle}: ${match[1]}` : null
            })
            .filter(Boolean)
            .join('\n')
        }
      },
      { immediate: true },
    )

    return {
      openDownloadLabelsModal,
      openDownloadDocuments,
      errorMessage,
      documentsUrl,
      assignment,
    }
  },
})
</script>
